import { FC } from 'react';

import { ACCOUNT_ID, NON_BREAKING_SPACE } from 'utils/constants/common';

import { Card, Cell, CellText, Radio } from '@hh.ru/magritte-ui';

interface AccountSwitcherOptionProps {
    accountId: number;
    accountTitle: string;
    checked?: boolean;
    onClick?: () => void;
}

export const AccountSwitcherOption: FC<AccountSwitcherOptionProps> = ({
    accountId,
    accountTitle,
    checked,
    onClick,
}) => {
    return (
        <Card borderWidth="default" padding={16} borderRadius={16} data-qa="account-switcher-option" hoverEnabled>
            <Cell left={<Radio checked={!!checked} onChange={onClick} />}>
                <CellText data-qa="account-switcher-option-text">{accountTitle}</CellText>
                <CellText type="subtitle" data-qa={checked ? 'active-account-aid' : 'account-aid'}>
                    {ACCOUNT_ID}
                    {NON_BREAKING_SPACE}
                    {accountId}
                </CellText>
            </Cell>
        </Card>
    );
};
